<template>
    <div class="flex relative">
        <side-bar />
        <div class="grid grid-cols-6 h-screen w-full relative bg-snow-300 z-10">
            <div
                class=" col-span-6 xl:col-span-4 overflow-auto  bg-white"
                :class="activeState === 'form' ? 'shadow-left ' : 'xl:block hidden'"
            >
                <div class="relative">
                    <div class="min-h-screen w-full absolute form-overlay z-20" v-show="activeState !== 'form'"></div>
                </div>
                <div>
                    <slot />
                </div>
            </div>
            <div
                class="col-span-6 xl:col-span-2 md:h-screen items-center flex-col justify-center relative my-10 md:my-0"
                :class="activeState !== 'pay' ? 'xl:flex hidden bg-snow-300' : 'flex bg-snow-300'"
            >
                <div class="h-screen w-full absolute z-10 overlay" v-show="activeState !== 'pay'"></div>
                <!-- <div
                    @click="() => switchState('form')"
                    :class="
                        `flex items-center pl-6 pb-2 font-medium text-lg text-smoke-200 cursor-pointer self-start ${
                            activeState === 'pay' ? 'opacity-100' : 'opacity-0'
                        }`
                    "
                >
                    <p class="pt-1">
                        Go Back
                    </p>
                    <svg
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="ml-2"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.8572 5.14281H2.68716L5.80118 1.40565C6.10461 1.04221 6.0549 0.501354 5.69147 0.198781C5.32718 -0.10465 4.78717 -0.0549354 4.4846 0.308495L0.198858 5.45139C0.16543 5.49167 0.148287 5.53882 0.123429 5.58339C0.102858 5.61939 0.0780005 5.65024 0.0625718 5.68967C0.0240002 5.78825 0.000857148 5.89196 0.000857148 5.99653C0.000857148 5.99739 0 5.9991 0 5.99996C0 6.00082 0.000857148 6.00253 0.000857148 6.00339C0.000857148 6.10796 0.0240002 6.21168 0.0625718 6.31025C0.0780005 6.34968 0.102858 6.38053 0.123429 6.41653C0.148287 6.46111 0.16543 6.50825 0.198858 6.54854L4.4846 11.6914C4.65432 11.8946 4.89775 12 5.14289 12C5.33661 12 5.53118 11.9349 5.69147 11.8011C6.0549 11.4986 6.10461 10.9577 5.80118 10.5943L2.68716 6.85711H12.8572C13.3304 6.85711 13.7144 6.47311 13.7144 5.99996C13.7144 5.52681 13.3304 5.14281 12.8572 5.14281Z"
                            fill="#D3DCE6"
                        />
                    </svg>
                </div> -->
                <div class="w-11/12 mx-auto px-2">
                    <pay-info
                        @initTransaction="initTransaction"
                        :transaction_details="transaction"
                        :payload="payload"
                        :error="error"
                        @go-back="goBack"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './includes/SideBar'
import PayInfo from '../components/PayInfo'

export default {
    components: {
        SideBar,
        PayInfo,
    },

    data() {
        return {
            activeState: 'form',
        }
    },

    props: {
        transaction: Object,
        payload: Object,
        error: Boolean,
        checker: Boolean,
    },

    mounted() {
        if (document.querySelector('form')) {
            document.querySelector('.form-overlay').style.height =
                document.querySelector('form').offsetHeight + 420 + 'px'
        } else {
            document.querySelector('.form-overlay').style.height = 890
        }
    },

    watch: {
        checker: function() {
            if (Object.entries(this.transaction).length) {
                this.activeState = 'pay'
            }
        },
    },

    methods: {
        initTransaction(val) {
            this.$emit('proceed', val)
        },

        goBack() {
            this.activeState = 'form'
        },
    },
}
</script>

<style lang="scss" scoped>
.shadow-left {
    box-shadow: 0px -4px 50px rgba(0, 0, 0, 0.05);
}
.shadow-info {
    box-shadow: 0px 4px 80px rgba(0, 0, 0, 0.05);
}
.shadow-left::-webkit-scrollbar {
    display: none !important;
}
.shadow-left::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    // border-radius: 10px;
    // background-color: #F5F5F5;
    display: none;
}

.overlay {
    &:hover {
        backdrop-filter: blur(2px);
    }
}

.form-overlay {
    background: rgba(60, 25, 82, 0.1);
    backdrop-filter: blur(3px);
    height: 100%;
}
</style>
